// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".news-container[data-v-59beeb80]{padding:77px 0 67px}.news-container .title[data-v-59beeb80]{margin-bottom:38px;color:#000;text-align:center;font-size:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
